import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import NonAuthenticatedModal from 'components/NonAuthenticatedModal/NonAuthenticatedModal';

import useAuth from 'hooks/useAuth';
import Login from 'pages/auth/Login/Login';
import { PATH_AUTH } from 'routes/paths';
import PageZoom from 'components/PageZoom/PageZoom';

const PUBLIC_PATHS = ['/dashboard', '/dashboard/courses'];
// Only the courses/public/* routes are anonymous. This must stay a full path
// segment: a bare '/dashboard/courses/' prefix also matches the private tree
// (courses/:course, courses/:course/:module, .../:lesson/:topic) and would make
// every course anonymously browsable.
const PUBLIC_COURSE_PREFIX = '/dashboard/courses/public/';

const AuthGuard: React.FunctionComponent = ({ children }) => {
    const { isAuthenticated, isVerified } = useAuth();
    const { pathname } = useLocation();
    const [requestedLocation, setRequestedLocation] = useState<string | null>(null);
    const [showModal, setShowModal] = useState(() => !localStorage.getItem('contactUserEmail'));

    const isPublicPath = PUBLIC_PATHS.includes(pathname) || pathname.startsWith(PUBLIC_COURSE_PREFIX);

    if (!isAuthenticated && isPublicPath) {
        return (
            <>
                <div style={{ position: 'fixed', top: '2rem', right: '1rem', zIndex: 1201 }}>
                    <PageZoom />
                </div>
                <NonAuthenticatedModal open={showModal} setOpen={setShowModal} />
                <>{children}</>
            </>
        );
    }

    if (!isAuthenticated) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <Login />;
    }

    if (!isVerified) {
        return <Navigate to={PATH_AUTH.verify} replace />;
    }

    if (requestedLocation && pathname !== requestedLocation) {
        setRequestedLocation(null);
        return <Navigate to={requestedLocation} />;
    }

    return (
        <>
            <div style={{ position: 'fixed', top: '2rem', right: '1rem', zIndex: 1201 }}>
                <PageZoom />
            </div>
            <>{children}</>
        </>
    );
};

export default AuthGuard;
